// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.has-addons[data-v-02e60981] {\n  margin-bottom: 1.5em;\n}\n.form-checkbox-set[data-v-02e60981] {\n  margin-bottom: 1em;\n}\nli[data-v-02e60981] {\n  margin-bottom: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
